import actions from './actions';
import mutations from './mutations';
import getters from "./getters";

const state = {
    store_id: null,
    store_name: null,
    industry_id: null,
    seat_num: null,
    date_from: null,
    date_to: null,
    saveStatus: false,
    changeStatus: false,
    isComparison: false
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};